<div class="card form-right">
  <div class="back">
    <h2>{{ "communication.voip.contacts" | translate }}</h2>
    <i class="icon-cross2" (click)="emitBack()"></i>
  </div>

  <div class="card-body">
    <!-- Search -->
    <div class="agenda-search mb-3" *ngIf="activeTab !== 'recents'">
      <div class="search-input-wrap">
        <i class="icon-magnifier"></i>
        <input type="text" class="form-control search-input"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange()"
          [placeholder]="'communication.voip.search_contacts' | translate">
        <button class="search-clear-btn" *ngIf="searchText" (click)="searchText = ''; onSearchChange()">
          <i class="icon-cross"></i>
        </button>
      </div>
    </div>

    <!-- Filter tabs -->
    <div class="agenda-tabs mb-3">
      <button class="btn btn-sm" [ngClass]="activeTab === 'all' ? 'btn-primary' : 'btn-hover'"
        (click)="setTab('all')">
        {{ "communication.voip.all_contacts" | translate }}
      </button>
      <button class="btn btn-sm" [ngClass]="activeTab === 'favorites' ? 'btn-primary' : 'btn-hover'"
        (click)="setTab('favorites')">
        <i class="icon-star"></i> {{ "communication.voip.favorites" | translate }}
      </button>
      <button class="btn btn-sm" [ngClass]="activeTab === 'recents' ? 'btn-primary' : 'btn-hover'"
        (click)="setTab('recents')">
        <i class="icon-clock"></i> {{ "communication.voip.recents" | translate }}
      </button>
    </div>

    <!-- Loading -->
    <div class="loading-state" *ngIf="isLoading">
      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
    </div>

    <!-- Contacts list (All / Favorites) -->
    <div class="contacts-list" *ngIf="!isLoading && activeTab !== 'recents'">
      <div class="contact-card" *ngFor="let contact of contacts">
        <div class="row align-items-center">
          <div class="col-10">
            <div class="contact-header">
              <div class="contact-avatar">{{ getInitial(contact.name) }}</div>
              <div class="contact-info">
                <div class="contact-name">
                  {{ contact.name }}
                  <i class="icon-star contact-fav" [class.active]="contact.is_favorite"
                    (click)="toggleFavorite(contact)"></i>
                </div>
                <div class="contact-company" *ngIf="contact.email">{{ contact.email }}</div>
              </div>
            </div>

            <div class="contact-details">
              <div class="contact-row-info">
                <i class="icon-telephone"></i>
                <span>{{ contact.phone }}</span>
                <span class="text-muted ms-1" *ngIf="contact.phone_e164">({{ contact.phone_e164 }})</span>
              </div>

              <div class="contact-refs" *ngIf="contact.order_references && contact.order_references.length > 0">
                <span class="badge text-campaign me-1" *ngFor="let ref of contact.order_references">
                  <i class="icon-clipboard-check"></i> {{ ref | slice:0:13 }}...
                </span>
              </div>

              <div class="contact-last-call" *ngIf="contact.last_call_at">
                <i class="icon-clock"></i>
                {{ "communication.voip.last_call" | translate }}: {{ formatLastCall(contact.last_call_at) }}
              </div>
            </div>
          </div>
          <div class="col-2 d-flex justify-content-center">
            <button class="btn btn-call-contact-lg"
              [disabled]="!contact.phone_e164"
              (click)="onCallContact(contact)"
              [title]="'communication.voip.call_now' | translate">
              <i class="icon-telephone"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="contacts.length === 0">
        <i class="icon-user"></i>
        <p>{{ "communication.voip.no_contacts" | translate }}</p>
      </div>
    </div>

    <!-- Recents list -->
    <div class="contacts-list" *ngIf="!isLoading && activeTab === 'recents'">
      <div class="contact-card" *ngFor="let recent of recents">
        <div class="row align-items-center">
          <div class="col-10">
            <div class="contact-header">
              <div class="contact-avatar">{{ getInitial(recent.name || recent.number) }}</div>
              <div class="contact-info">
                <div class="contact-name">
                  {{ recent.client?.name || recent.name || recent.number }}
                  <i class="icon-star contact-fav" [class.active]="recent.is_favorite"
                    *ngIf="recent.client"></i>
                </div>
                <div class="contact-company">{{ recent.number }}</div>
              </div>
            </div>

            <div class="contact-details">
              <div class="contact-row-info">
                <i [class]="getDirectionIcon(recent.last_call.direction)"
                  [ngClass]="getStatusClass(recent.last_call.status)"></i>
                <span class="text-muted">{{ formatLastCall(recent.last_call_at) }}</span>
                <span class="badge bg-light text-dark ms-1">{{ recent.calls_count }} {{ "communication.voip.calls" | translate }}</span>
              </div>
            </div>
          </div>
          <div class="col-2 d-flex justify-content-center">
            <button class="btn btn-call-contact-lg" (click)="onCallRecent(recent)"
              [title]="'communication.voip.call_now' | translate">
              <i class="icon-telephone"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="recents.length === 0">
        <i class="icon-clock"></i>
        <p>{{ "communication.voip.no_recents" | translate }}</p>
      </div>
    </div>
  </div>
</div>
